import { useState, useEffect } from 'react';
import { notificationApi } from '@sinups/ui-kit';

interface InfiniteLoaderProps {
  initialCount?: number;
}

export function useNotificationsLoader({ initialCount = 10 }: InfiniteLoaderProps) {
  const [offset, setOffset] = useState(0);
  const [count] = useState(initialCount);
  const [hasMore, setHasMore] = useState(true);

  const { data, isFetching, isLoading } = notificationApi.useGetNotificationsQuery({
    count,
    offset,
    isAll: true
  });

  useEffect(() => {
    if (data?.count) {
      if (data.count < count) {
        setHasMore(false);
      }
    }
  }, [data?.notifications, count]);

  const loadMore = () => {
    if (!isFetching && !isLoading && hasMore) {
      setOffset((prev) => prev + count);
    }
  };

  return {
    loadMore,
    isLoading: isFetching || isLoading,
    notifications: data?.notifications ?? [],
    hasMore,
    lastSeenAt: data?.lastSeenAt ?? ''
  };
}
